import { Component, OnInit } from '@angular/core';
import { UserService } from '../../system/services/usuario.service';
import { NgForm } from '@angular/forms';
import { NotifierService } from '../../system/shared/notifier/notifier.service';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.scss'],
  providers:[UserService]
})
export class RecoveryPasswordComponent implements OnInit {
  recoveryData: any;
  constructor(private userService: UserService, private notifierService: NotifierService) {
    this.recoveryData = {};
  }

  ngOnInit() {
  }

  sendRecoveryMail(form: NgForm) {
    if (form.valid) {
      this.userService.recoverPassword(this.recoveryData.correo).subscribe((result) => {
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha registrado su solicitud, en breves le llegará un mensaje a su correo con las instrucciones a seguir',
          duration: 6000,
          type: 'success'
        });
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'Error',
          message: error.message,
          type: 'error'
        });
      });
    } else {
      this.notifierService.systemNotify({
        title: 'Atención',
        message: 'Por favor llene el campo para poder registrar su solicitud',
        type: 'warning'
      })
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/public/recovery-password/recovery-password.component.ts